var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5002 5C14.5002 3.067 16.0672 1.5 18.0002 1.5C19.9332 1.5 21.5002 3.067 21.5002 5C21.5002 6.93298 19.9332 8.5 18.0002 8.5C16.0672 8.5 14.5002 6.93298 14.5002 5ZM18.0002 3.5C17.1718 3.5 16.5002 4.17158 16.5002 5C16.5002 5.82841 17.1718 6.5 18.0002 6.5C18.8286 6.5 19.5002 5.82841 19.5002 5C19.5002 4.17158 18.8286 3.5 18.0002 3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67453 6.05404C9.92294 5.96803 10.1952 5.98329 10.4325 6.09652L15.9309 8.72082C16.2471 8.87174 16.4613 9.17712 16.4954 9.52582C16.5296 9.87451 16.3787 10.2157 16.0978 10.425L11.7431 13.6712L16.05 16.5064C16.2805 16.6582 16.438 16.8984 16.4854 17.1702C16.5327 17.442 16.4656 17.7213 16.2999 17.942L12.8041 22.5993C12.4725 23.041 11.8457 23.1303 11.404 22.7988C10.9623 22.4672 10.873 21.8404 11.2046 21.3987L14.0619 17.5921L9.45188 14.5574C9.17951 14.3781 9.01167 14.0772 9.00215 13.7513C8.99263 13.4254 9.14263 13.1152 9.40407 12.9204L13.5739 9.81198L9.94124 8.07819L6.32737 9.32951C5.80549 9.51021 5.23592 9.23363 5.05522 8.71174C4.87452 8.18986 5.1511 7.6203 5.67298 7.43959L9.67453 6.05404Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7291 8.04814C23.1073 8.45064 23.0876 9.08349 22.6851 9.46167L19.6859 12.2797C19.3714 12.5753 18.9026 12.6356 18.5234 12.4294L17.1826 11.7002C16.6974 11.4363 16.518 10.8291 16.7818 10.3439C17.0457 9.85877 17.6529 9.67935 18.1381 9.94321L18.8435 10.3269L21.3156 8.00413C21.7181 7.62595 22.3509 7.64565 22.7291 8.04814Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02934 14.9762C9.46922 15.3102 9.55511 15.9375 9.22116 16.3774L7.73631 18.3333C7.65333 18.4426 7.54873 18.5336 7.42903 18.6008L2.49134 21.3704C2.00965 21.6405 1.40015 21.4691 1.12996 20.9874C0.859782 20.5057 1.03124 19.8962 1.51292 19.626L6.26915 16.9582L7.62819 15.168C7.96214 14.7282 8.58945 14.6423 9.02934 14.9762Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.c27e9fbbd2535b775edb77d6d421d45d.svg";
export { ForwardRef as ReactComponent };